export default __webpack_public_path__ + "static/media/gojelly_site_bg_03.b4ea6a31.jpg";